module.exports = __webpack_public_path__ + "assets/img/default-portrait.fbdbe689.png";